/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * メディアの発行部数/PVについて
 * @export
 * @enum {string}
 */
export enum MediaReach {
    NONE_DATA = 'データ無し',
    UNDER_10K = '1万以下',
    FROM_10K_TO_50K = '1万~5万',
    FROM_50K_TO_100K = '5万~10万',
    FROM_100K_TO_500K = '10万~50万',
    FROM_500K_TO_1M = '50万~100万',
    FROM_1M_TO_5M = '100万~500万',
    FROM_5M_TO_10M = '500万~1000万',
    OVER_10M = '1000万以上'
}

export function MediaReachFromJSON(json: any): MediaReach {
    return MediaReachFromJSONTyped(json, false);
}

export function MediaReachFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaReach {
    return json as MediaReach;
}

export function MediaReachToJSON(value?: MediaReach | null): any {
    return value as any;
}

